import { render, staticRenderFns } from "./SubscriptionPlans.vue?vue&type=template&id=634d032c&scoped=true"
import script from "./SubscriptionPlans.vue?vue&type=script&lang=js"
export * from "./SubscriptionPlans.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionPlans.vue?vue&type=style&index=0&id=634d032c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634d032c",
  null
  
)

export default component.exports